// Состояние всплывающих слоёв «умного СТО» над редактором: подсказка живой проверки (при наведении на
// подчёркивание) и список «@»-ссылок. Отрисовывает их OverlayHost (overlays.tsx) через портал.
import { createStore, useStore } from 'zustand';
import type { InlineIssue } from './inlineLint';

export interface TipState { x: number; y: number; issues: InlineIssue[] }
export interface MentionState {
  /** позиция символа «@» и текст запроса после него */
  from: number; to: number; query: string;
  /** координаты курсора для размещения списка */
  left: number; top: number; bottom: number;
  index: number; phrase: string | null;
}

interface OverlayState {
  tip: TipState | null;
  mention: MentionState | null;
  set: (p: Partial<Omit<OverlayState, 'set'>>) => void;
}

export const overlay = createStore<OverlayState>()((set) => ({
  tip: null,
  mention: null,
  set: (p) => set(p),
}));

export function useOverlay<T>(sel: (s: OverlayState) => T): T {
  return useStore(overlay, sel);
}
